// Извлекает текст из загруженного файла для ручной подачи в анализ.
// Поддержка: .txt (и прочий plain text) — нативно; .docx — через mammoth.
// mammoth тяжёлый (~прибавляет сотни КБ), поэтому грузим его лениво —
// только когда реально открывают .docx, чтобы не утяжелять старт приложения.
export async function fileToText(file) {
  const name = (file.name || '').toLowerCase();
  if (name.endsWith('.docx')) {
    const { default: mammoth } = await import('mammoth/mammoth.browser');
    const arrayBuffer = await file.arrayBuffer();
    const { value } = await mammoth.extractRawText({ arrayBuffer });
    return value;
  }
  return file.text();
}
